import React, { useEffect, useState } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { DEFAULT_IMAGEBOSS_URL } from "../../../utils/S3";
import AuthService from "../../../AuthService";


const DialogProfileLogo = ({ open, onClose, onConfirm, empresa }) => {
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const [empresaCopy, setEmpresaCopy] = useState(null);
  const [formatoLogo, setFormatoLogo] = useState("circular");


  // ADICIONADO - Instanciamos o serviço para fazer chamadas à API
  const service = new AuthService();

  let fileSrc = file ? URL.createObjectURL(file) : null;
  fileSrc = fileSrc || empresaCopy?.urlLogo || null;

  useEffect(() => {
    setEmpresaCopy({ ...empresa });
    setFormatoLogo(empresa.formatoLogo === "square" ? "rounded" : "circular");
  }, [empresa, open]);

  function onChangeRadioLogo(event) {
    setFormatoLogo(event.target.value);
  }

   async function uploadFileToServer(file) {
    try {
      // 1. Chamar seu backend para obter a URL assinada
      const presignedResponse = await service.post("/S3Service/generate-presigned-url", {
        fileName: file.name,
        fileType: file.type,
        empresaId: empresaCopy.id,
      });

      const { uploadUrl, key } = presignedResponse;

      // 2. Fazer o upload do arquivo para o S3 com a URL recebida
      const uploadResponse = await fetch(uploadUrl, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": file.type,
        },
      });

      if (!uploadResponse.ok) {
        throw new Error("Falha no upload do logo para o S3!");
      }

      // 3. Retornar a URL final da imagem para exibição
      const finalUrl = `${DEFAULT_IMAGEBOSS_URL}/cover:center/200x200/${key}`;
      return finalUrl;

    } catch (error) {
      console.error(error);
      // Lançar o erro novamente para que o `handleConfirm` possa capturá-lo
      throw error; 
    }
  }

  async function handleConfirm() {
    setSaving(true);

    try {
      let url = empresaCopy?.urlLogo;
      if (file) {
        url = await uploadFileToServer(file);
      }

      const empresaCopyUpdated = { ...empresaCopy };

      empresaCopyUpdated.urlLogo = url;
      empresaCopyUpdated.formatoLogo =
        formatoLogo === "rounded" ? "square" : "circular";

      onConfirm(empresaCopyUpdated);
    } catch (error) {
      console.error(error);
    } finally {
      setSaving(false);
    }
  }

  function removerLogo() {
    const empresaCopyUpdated = { ...empresaCopy };
    empresaCopyUpdated.urlLogo = null;

    setFile(null);
    setEmpresaCopy(empresaCopyUpdated);
  }

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle align="center">Alterar foto de perfil</DialogTitle>

      <DialogContent>
        <input
          type="file"
          id="fileElem"
          accept="image/*"
          style={{ display: "none" }}
          onChange={(event) => setFile(event.target.files[0])}
        />

        <Box display="flex" alignItems="flex-start">
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            flexGrow={1}
          >
            {fileSrc ? (
              <>
                <Avatar
                  variant={formatoLogo}
                  alt="Logo da empresa"
                  src={fileSrc}
                  sx={{
                    width: "180px",
                    height: "180px",
                    cursor: "pointer",
                    zIndex: 1,

                    "&:hover": {
                      opacity: "0.5",
                    },
                  }}
                  onClick={() => document.getElementById("fileElem").click()}
                />

                <Button style={{ marginTop: "8px" }} onClick={removerLogo}>
                  Remover logo
                </Button>
              </>
            ) : (
              <Avatar
                alt="Logo da empresa"
                variant={formatoLogo}
                src={fileSrc}
                sx={{
                  width: "180px",
                  height: "180px",
                  cursor: "pointer",
                  zIndex: 1,

                  "&:hover": {
                    opacity: "0.5",
                  },
                }}
                onClick={() => document.getElementById("fileElem").click()}
              />
            )}
          </Box>

          <RadioGroup value={formatoLogo} onChange={onChangeRadioLogo}>
            <FormControlLabel
              value="circular"
              control={<Radio />}
              label={
                <AccountCircleIcon
                  sx={{
                    width: "110px",
                    height: "110px",
                    cursor: "pointer",
                    zIndex: 1,
                    transition: "0.2s",

                    "&:hover": {
                      opacity: "0.5",
                    },
                  }}
                />
              }
            />
            <FormControlLabel
              value="rounded"
              control={<Radio />}
              label={
                <AccountBoxIcon
                  sx={{
                    width: "110px",
                    height: "110px",
                    cursor: "pointer",
                    zIndex: 1,
                    transition: "0.2s",

                    "&:hover": {
                      opacity: "0.5",
                    },
                  }}
                />
              }
            />
          </RadioGroup>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          disabled={saving}
          color="primary"
          variant="contained"
          onClick={handleConfirm}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogProfileLogo;
